import { type IReactionDisposer, makeAutoObservable } from 'mobx'
import { type CustomField, CustomFieldsStore } from 'entities/CustomField'

export class DateFieldDropdownStore {
  dispose: IReactionDisposer | null = null
  customFieldsStore
  constructor(private onSetDateField: (dateFiled: CustomField) => void) {
    this.customFieldsStore = new CustomFieldsStore()
    makeAutoObservable(this)
  }

  init = async (date_field?: string) => {
    try {
      if (!this.customFieldsStore.fields.length) {
        await this.customFieldsStore.loadData({ types: ['date', 'datetime'], all: true })
      }
      if (date_field) {
        this.dateFiled =
          this.customFieldsStore.fields.find((field) => field.key === date_field) || null
      }
    } catch (e) {
      console.error(e)
    }
  }

  dateFiled: CustomField | null = null
  setDateFiled = (dateFiled: CustomField) => {
    this.onSetDateField(dateFiled)
    this.dateFiled = dateFiled
  }

  get customFields() {
    return this.customFieldsStore.fields
  }
  get loading() {
    return this.customFieldsStore.loading
  }
}
